module.exports = __webpack_public_path__ + "static/media/icon-announce-schedule.d107c587.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-announce-schedule.svg
// module id = ./src/assets/images/icon-announce-schedule.svg
// module chunks = 6